import { render, staticRenderFns } from "./ListCrew.vue?vue&type=template&id=223ba988&scoped=true"
import script from "./ListCrew.vue?vue&type=script&lang=js"
export * from "./ListCrew.vue?vue&type=script&lang=js"
import style0 from "./ListCrew.vue?vue&type=style&index=0&id=223ba988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ba988",
  null
  
)

export default component.exports